export default __webpack_public_path__ + "static/media/093-up-arrow-4.83998f2b.png";